export interface IOptimizationType {
    title: string;
    value: string;
    }

export const Total: IOptimizationType = {
    title: "Total",
    value: "total"
};

export const Carry: IOptimizationType = {
    title: "Carry",
    value: "carry"
};
    
export const High: IOptimizationType = {
    title: "High",
    value: "high"
};

export const Combined: IOptimizationType = {
    title: "Carry & Total",
    value: "combined"
};

export const DefaultOptimizedTypes: Array<IOptimizationType> = [
    Carry, 
    Total, 
    Combined
];

export function GetDefaultOptimizedType(s:string) :IOptimizationType{
    switch(s.toLowerCase()){
        case "carry":
            return Carry;
        case "total":
            return Total;
        case "combined":
            return Combined;
        default:
            return Carry;
    }
}